import { abyssColors } from '@/theme/colors';
import { Box, Button, Typography, styled as muiStyled } from '@mui/material';

type ButtonProps = {
  contained?: boolean;
  isError?: boolean;
  isWarning?: boolean;
};

export const containerStyles = {
  width: 1,
  position: 'relative',
  pt: '3.2rem',
  pb: 0,
  paddingX: 4,
  overflow: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const zonesManagementStyles = {
  width: '100%',
  maxWidth: { xl: '1424px', md: '1100px' },
  marginX: 4,
  marginBottom: 8,
  height: 'fit-content',
};

export const DeploymentTitle = muiStyled(Typography)(() => ({
  fontSize: '2.4rem',
  fontWeight: 700,
  color: abyssColors.primary[600],
  lineHeight: '100%',
  paddingRight: '5px',
  maxWidth: '60%',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
}));

export const ActionButton = muiStyled(Button)(({ contained }: ButtonProps) => ({
  padding: '0.6rem 1.2rem',
  height: '3.4rem',
  borderRadius: '0.4rem',
  fontSize: '1.4rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  border: contained ? 'none' : `0.1rem solid ${abyssColors.primary[500]}`,
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : abyssColors.neutral[50],
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : abyssColors.neutral[50],
  },
  '& span': {
    fontWeight: 600,
    margin: '0 0.6rem',
  },
}));

export const taskTabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',

  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'auto',
    padding: '1.2rem 0rem',
    paddingRight: '2.4rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    letterSpacing: '0.014rem',
    fontWeight: 400,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[400]} !important`,
  },
  '& .MuiTab-root.Mui-selected span': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 700,
  },
  '& .MuiTab-textColorPrimary span': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0.2rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
  opacity: 0.5,
}));
